import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '@/views/Login';
import Main from '@/views/Main';
import BaseView from '@/components/main/BaseView';
import Dashboard from '@/views/Dashboard';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Login
  },
  {
    path: "/",
    component: Main,
    beforeEnter(to, from, next) {
      if (store.state.token) {
        next();
      } else {
        next("/");
      }
    },
    children: [
      { 
        path: '/dashboard', 
        component: Dashboard,
        meta: { requiresAuth: true }
      },
      { 
        path: '/usuario',
        component: BaseView,
        children: [
          {
            path: '/',
            name: 'list-usuario',
            component: () => import("@/views/usuario/List.vue"),
            meta: { requiresAuth: true }
          },
          {
              path: ':id',
              name: 'form-usuario',
              component: () => import("@/views/usuario/Form.vue"),
              meta: { requiresAuth: true }
          }
        ]
      },
      { 
        path: '/denuncia',
        component: BaseView,
        children: [
          {
            path: '/',
            name: 'list-denuncia',
            component: () => import("@/views/denuncia/List.vue"),
            meta: { requiresAuth: true }
          },
          {
              path: ':id',
              name: 'form-denuncia',
              component: () => import("@/views/denuncia/Form.vue"),
              meta: { requiresAuth: true }
          }
        ]
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: "active",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    $(".preloader").children().show();
    $(".preloader").css('height', '100%');
  
    setTimeout(function () {  
      $(".preloader").css('height', 0);      
      setTimeout(function () {
        $(".preloader").children().hide();
      }, 200);
    }, 500);
  
    if (store.state.token) {
      next();
    } else {
      next("/");
    }
  } else {
    next();
  }
});

export default router;